module.exports = __webpack_public_path__ + "static/media/servicebg.c6464190.png";